import React, {Component} from 'react';
import axios from 'axios';

const Context = React.createContext();
const reducer = (state,action)=> {
    switch(action.type){
        case 'DELETE_CONTACT':
            return{
                ...state,
                contacts: state.contacts.filter(contact=> contact.id !== action.payload)
            }
        case 'ADD_CONTACT':
            return{
                ...state,
                contacts: [
                    action.payload,     
                    ...state.contacts
                ]
            }
        case 'UPDATE_CONTACT':
            return{
                ...state,
                contacts: state.contacts.map(contact=> 
                    contact.id === action.payload.id ? (contact=action.payload) : contact
                )
            }
        default:
            return state;
    }
}

export class Provider extends Component{
    state = {
        contacts:[

            
           /* dummy data removed {
                id:1,
                name:"Dave Kidd",
                email:"dave@davekidd.net",
                phone:"999-999-9999"
            },
            {
                id:2,
                name:"Fred Magilicutty",
                email:"fred@fred.org",
                phone:"777-777-7777"
            },
            {
                id:3,
                name:"George Curious",
                email:"monkey@curious.com",
                phone:"111-111-1111"
            }*/
        ],
        dispatch: action => this.setState(state => reducer(state,action))
    }

    async componentDidMount(){
        const res = await axios.get("https://jsonplaceholder.typicode.com/users");        
        this.setState({contacts:res.data});
    }
    
    render(){
        return(
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        )
    }
}

export const Consumer = Context.Consumer;